import { render, staticRenderFns } from "./career.vue?vue&type=template&id=56f2c098&scoped=true"
import script from "./career.vue?vue&type=script&lang=js"
export * from "./career.vue?vue&type=script&lang=js"
import style0 from "./career.vue?vue&type=style&index=0&id=56f2c098&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56f2c098",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {MainButton: require('/app/components/main/buttons/MainButton.vue').default})
